import { forwardRef, memo, useState, useCallback, useEffect, useMemo } from 'react';
import { Container, Row, Col, Dropdown } from 'react-bootstrap';
import { useLocation, useNavigate } from 'react-router';
import { Link } from 'react-router-dom';
import { BzDropdown, BzToolTip } from '../../components';
import DashMenu from './DashMenu';
import { resetAllAuthData, updateIsLoading, updateMpinEnabled, updateUserId, userSwitch } from '../../redux/actions/auth';
import { useDispatch, useSelector } from 'react-redux';
import { handleModal, handleModalData } from '../../redux/actions/modals';
import Notification from './Notification/Notification';
import NotificationModal from './Notification/NotificationModal';
import Skeleton from 'react-loading-skeleton';
import 'react-loading-skeleton/dist/skeleton.css';
//PrachiTawde : 05-05-2023 : BT-107252 -  Breeze – Rate us & Feedback - Start
import {
    compareDates, convertScripResponseWatchlistGrid, getApiExchangeNameFromMktSegId, getAppInfoData, getDecryptLocalStorage,
    getMktSegIdFromMappedMktSegId, onUserLoggedInActiveSession, setEncryptLocalStorage, isUserIsAGuest, validateEmail, getStorageWithMultiTabCheck, setStorageWithMultiTabCheck, setStorageWithMultiTabCheckWithoutEncryption, getStorageWithMultiTabCheckWithoutEncryption, removeStorageWithMultiTabCheck, handleOpenMode
} from '../../utils/global_functions';
import {
    APP_INFO_PARAMS, DEFAULT_FAVOURITE_INDICES, DONT_MISS_WATCHLIST_NAME, DYANMIC_URL_CONSTANTS,
    EXCHANGE_NAME_API, LOCATIONS, LOCAL_STORAGE_KEYS, MESSAGE_HUB,
    TL_INDEX, WATCHLIST_GRID_INDEX, EXCHANGE_NAME_NOTIFICATION, APP_INFO_DEFAULT_VALUES, DEFAULT_PAGE_SIZE
} from '../../utils/global_variables';
//PrachiTawde : 05-05-2023 : BT-107252 -  Breeze – Rate us & Feedback - End
import ProfileModal from '../UserProfile/ProfileModal';
import moment from 'moment';
import { UsageGuide, PrivacyPolicy, KeyboardShortcuts, ContactUs } from '../Help';
import { TermsConditionModal, AboutUsModal, DoneOverlay, LoginLoader } from '../Login';
import { walkthroughPopoversContentUpdate } from "../../redux/actions/walkthroughPopovers";
import { getAboutUs, getDisclaimer, getTermsAndCondition, openHamburgerMenu } from '../../redux/actions/appInfo';
import GuestUserProfileModal from '../UserProfile/GuestUserProfileModal';
import config from '../../config.json';
import {
    getMessagesBroker, getMessagesOrders, getMessagesNse, getMessages, setNotifCountBroker, setNotifCountOrder,
    setNotifCountExchange, MessagesNse, updateNotificationsCountStatus, updateMsgActiveChip, updateStrExchangeNotification
} from '../../redux/actions/messages';
import ProfileSettingsModal from '../UserProfile/ProfileSettingsModal';
import { _getInitialsFromUserName, _userType } from '../../controllers';
import LogOutConfirmationModal from '../UserProfile/LogOutConfirmationModal';
import { AddEndumAndNoticesModal } from '../AddenddumNotices';
import ChangeMpin from '../Setting/ChangeMpin';
import Funds from '../Funds/Funds';
import { updateHoldingsWatchlist } from '../../redux/actions/watchlist';
import GuestUserRestrictionModal from '../GuestUserRestrictionModal';
import HeaderIndices from './HeaderIndices';
import { useWFHMessages } from '../../hooks';
import { getAndLoadLocalIndicesOnLoad, getIndices, getWorldIndicesData, setIndiceOverviewData, setIsIndicesOverview } from '../../redux/actions/indices';
import { getScripbyTokenAndMktSegId } from '../../apis';
import { setScripOverviewData } from '../../redux/actions/marketOverview';
import { toastConfig } from '../../redux/actions/toast';
import { getWfhTouchlineLastTick } from '../../redux/actions/wfh';
import { connectSocket, objTokenWiseTLSubscripionCounter, sendTouchlineRequest } from '../../apis/web_socket';
import DevToolsMsgModal from './DevToolsMsgModal';
import { getWhatsHotData } from '../../redux/actions/dontMiss';
import IFrame from '../IFrame';
import usePolling from '../../hooks/usePolling';
import { segmentWiseVersion } from '../../redux/actions/header';
import SegmentWiseVersionModal from '../UserProfile/SegmentWiseVersionModal';
import MarketStatusModal from './MarketStatusModal';
import { updateActiveMarket } from '../../redux/actions/funds';
import useAnalyticsEventTracker from '../../hooks/useAnalyticsEventTracker';




const CustomDropdownToggle = forwardRef(({ children, onClick }, ref) => (
    <div
        ref={ref}
        onClick={(e) => {
            e.preventDefault();
            onClick(e);
        }}
    >
        {children}
    </div>
));


const Header = () => {
    const { pathname } = useLocation();
    const modals = useSelector(state => state.modals.modals);
    const dispatch = useDispatch();
    //const cityTypeaheadRef = useRef();

    const headerIndicesFromRedux = useSelector(state => state?.indices?.headerIndices);
    //PrachiTawde : 05-05-2023 : BT-107252 -  Breeze – Rate us & Feedback - Start
    const appInfo = useSelector(state => state.appInfo.appInfo);
    //PrachiTawde : 05-05-2023 : BT-107252 -  Breeze – Rate us & Feedback - End
    const watchlists = useSelector(state => state?.watchList?.watchlists);
    const dontMissrefreshTimer = getAppInfoData(APP_INFO_PARAMS.APP_DONTMISS_REFRESH_TIMER, APP_INFO_DEFAULT_VALUES.MINIMUM_INTERVAL_TIME_FOR_WHATSHOTDATA_CALL);
    const nWhatsHotDataIntervalTime = useMemo(() => appInfo?.length > 0 && dontMissrefreshTimer >= APP_INFO_DEFAULT_VALUES.MINIMUM_INTERVAL_TIME_FOR_WHATSHOTDATA_CALL ? dontMissrefreshTimer * 60 * 1000 : APP_INFO_DEFAULT_VALUES.MINIMUM_INTERVAL_TIME_FOR_WHATSHOTDATA_CALL * 60 * 1000, [appInfo]);
    const [headerIndices, setHeaderIndices] = useState({});
    const [objScripsRequest, setObjScripsRequest] = useState({});
    const isSwitchUserDisabled = localStorage.getItem(LOCAL_STORAGE_KEYS.DISABLE_SWITCH_USER);
    const getEvent = useAnalyticsEventTracker("HEADER")
    const aboutUs = useSelector(state => state?.appInfo?.aboutUs);
    const aboutusInfo = getAppInfoData(APP_INFO_PARAMS.APP_ABOUTUS_URL);
    const disclaimer = useSelector(state => state?.appInfo?.disclaimer);
    const disclaimerInfo = getAppInfoData(APP_INFO_PARAMS.APP_DISCLAIMER_MODE);
    useEffect(() => {
        let interval;

        if (nWhatsHotDataIntervalTime) {
            interval = setInterval(() => {
                if (watchlists) {
                    const watchlistsWithoutDontmiss = watchlists?.filter((item) => item?.sWatchListName?.toLowerCase() !== DONT_MISS_WATCHLIST_NAME);
                    dispatch(getWhatsHotData(watchlistsWithoutDontmiss));
                }

            }, nWhatsHotDataIntervalTime);
        } else { }

        return (() => {
            clearInterval(interval);
        });
    }, [nWhatsHotDataIntervalTime, watchlists, dispatch]);
    useEffect(() => {
        if (appInfo && appInfo.length > 0) {


            //Monali G  : 01-03-2023  : BT-101819  -   Breeze - Login edge cases    -  Start
            dispatch(getTermsAndCondition()); //done
            dispatch(getAboutUs());// added by abhijeet v for checking is api data available
            dispatch(getDisclaimer());


            //Monali G  : 01-03-2023  : BT-101819  -   Breeze - Login edge cases    -   Ends
        } else { }


    }, [appInfo, dispatch]);

    const setHeaderData = useCallback((tldata) => {
        setHeaderIndices(prevState => {
            let prevStateCopy = prevState;
            headerIndicesFromRedux?.forEach(eachIndices => {
                let key = eachIndices?.nMarketSegmentId + '_' + eachIndices?.nToken;
                let abc = tldata[key];
                if (abc?.length > 0) {
                    let obj = updateLtpObjectForHeaderIndices(eachIndices, abc);
                    prevStateCopy[key] = obj;
                } else {
                    prevStateCopy[key] = eachIndices;
                }
            });

            return { ...prevStateCopy };
        });
    }, [headerIndicesFromRedux]);

    const handleLastTickOfIndices = useCallback(() => {
        const intervalid = setInterval(() => {
            let tldata = dispatch(getWfhTouchlineLastTick());
            if (Object?.keys(tldata)?.length > 0) {
                clearInterval(intervalid);
                setHeaderData(tldata);
            }
        }, 1000);
    }, [setHeaderData, dispatch]);

    useEffect(() => {
        if (headerIndicesFromRedux && headerIndicesFromRedux?.length > 0) {
            let objForReduxIndices = {};
            headerIndicesFromRedux.forEach(x => {
                let key = x?.nMarketSegmentId + '_' + x?.nToken;

                if (!objForReduxIndices[key]) {
                    objForReduxIndices[key] = x;

                }
            });
            setHeaderIndices({ ...objForReduxIndices });
            setEncryptLocalStorage(LOCAL_STORAGE_KEYS.HEADER_INDICES, JSON.stringify(headerIndicesFromRedux));
        }
    }, [dispatch, headerIndicesFromRedux]);


    useEffect(() => {
        let id1 = null;
        if (headerIndicesFromRedux?.length > 0) {
            // this code only runs once or else when a header is changed it wil run
            setObjScripsRequest(prevState => {

                let obj = prevState;
                let arrKeys = [];
                let subscribeScrips = [];
                let unSubScribeScrips = [];
                let objIndcies = {};
                headerIndicesFromRedux.forEach(x => {
                    let key = x?.nMarketSegmentId + '_' + x?.nToken;
                    arrKeys?.push(key);
                    objIndcies[key] = x;
                    if (!obj[key]) {
                        obj[key] = true;

                    }
                });
                Object?.keys(obj)?.forEach(key => {
                    if (arrKeys.includes(key)) {
                        let object = {
                            exchangeId: Number(key?.split('_')[0]),
                            token: Number(key?.split('_')[1]),
                            isSubscribe: true
                        };
                        subscribeScrips?.push(object);

                    } else {
                        let object1 = {
                            exchangeId: Number(key?.split('_')[0]),
                            token: Number(key?.split('_')[1]),
                            isSubscribe: false
                        };
                        unSubScribeScrips?.push(object1);
                        delete obj[key];
                    }
                });
                id1 = setTimeout(() => {
                    if (unSubScribeScrips?.length > 0) {
                        sendTouchlineRequest(unSubScribeScrips);
                    }
                    if (subscribeScrips?.length >= 0) {
                        sendTouchlineRequest(subscribeScrips);
                    }
                    handleLastTickOfIndices();
                }, 200);

                return obj;

            });

        }

        return () => {
            clearTimeout(id1);
        };
    }, [headerIndicesFromRedux, handleLastTickOfIndices]);
    const objLoginSession = useSelector(state => state.auth.objLoginSession);
    useEffect(() => {

        if (objLoginSession?.data?.access_token) {
            dispatch(getIndices());
            dispatch(getWorldIndicesData());
        }
    }, [dispatch, objLoginSession]);

    const userIdForFaq = useSelector(state => state.auth?.userId); // AJitesh : To get user id for FAQ URL
    const userPreference = useSelector(state => state.notification.userPreference);
    //Maaz A : 30-08-2023 : BT-116689 - Breeze - Create Dynamic Menu - Start
    const { mainMenu: objMainMenu = {} } = useSelector(state => state.appInfo.dynamicMenus);
    //Maaz A : 30-08-2023 : BT-116689 - Breeze - Create Dynamic Menu - End
    //PrachiTawde : 05-05-2023 : BT-109047 -  Breeze- User Profile - Start
    const statesCities = useSelector(state => state.appInfo?.statesCities);
    const userInfo = JSON.parse(getStorageWithMultiTabCheck(LOCAL_STORAGE_KEYS.USER_ACTIVE_SESSION));
    //PrachiTawde : 05-05-2023 : BT-109047 -  Breeze- User Profile - End
    const termsAndCondition = useSelector(state => state.appInfo.termsAndCondition);
    // {/* BT-121004 : Vinit Raut : 03-11-2023 Breeze- Hamburger Menu- Exchange Links bugfix - Start */ }
    const isDashMenu = useSelector(state => state.appInfo.dashMenu);
    // {/* BT-121004 : Vinit Raut : 03-11-2023 Breeze- Hamburger Menu- Exchange Links bugfix - End */ }
    const arrOrders = useSelector(state => state.messages.arrOrders); //  Hari K :06-11-2023: BT-109371 message hub -receving isReachedLimit
    const arrNse = useSelector(state => state.messages.arrNse);
    const arrBroker = useSelector(state => state.messages.arrBroker);
    const arrMessages = useSelector(state => state.messages.arrMessages);
    const [toggleThemeBtn, setToglThemeBtn] = useState(0);
    const [userDetails, setUserDetails] = useState([]);
    const [currentPreference, setCurrentPreference] = useState({});
    const isIndicesOverview = useSelector(state => state.indices.isIndicesOverview);

    //PrachiTawde : 05-05-2023 : BT-109047 -  Breeze- User Profile - Start

    //Hari K: 03-11-2023 : message hub - start
    const isReachedLimit = useSelector(state => state.messages);
    //Hari k:03-11-2023:message hub - end



    const [bIsDone, setbIsDone] = useState(false);
    const [spinner, setSpinner] = useState(false);
    const [registration, setRegistration] = useState({});
    const [stateSelected, setStateSelected] = useState([]);
    const [citySelected, setCitySelected] = useState([]);
    const [cityOptionData, setCityOptionData] = useState([]);
    const [bDisableEKycButton, setBDisableEKycButton] = useState(true);
    const [apiFired, setApiFired] = useState(false);

    //  Hari K :06-11-2023: BT-109371 message hub - issue maintaining individual stes for pages -start
    const [brokerPageNo, setBrokerPageNo] = useState(1);
    const [ordersPageNo, setOrdersPageNo] = useState(1);
    const [NsePageNo, setNsePageNo] = useState(1);
    //  Hari K :06-11-2023: BT-109371 message hub - issue maintaining individual stes for pages -end

    //shubham P : 16-06-23 : BT-107399 - Breeze - Notifications
    const [notificationShowPopover, setNotificationShowPopover] = useState(false);
    const [doneMessage, setDoneMessage] = useState('');
    const countExchange = useSelector(state => state?.messages?.countExchange);
    const countBroker = useSelector(state => state?.messages?.countBroker);
    const countOrder = useSelector(state => state?.messages?.countOrder);
    const [versionNumber, setVersionNumber] = useState(null); // Parshva S: 30/04/2024 : Added app version number

    // Ameersha N : 24-11-2023 : SAT-109371 : Message Hub – Start/
    const strNotificationActiveChip = useSelector(state => state?.messages?.msgActiveChip);
    const notificationExchange = useSelector(state => state?.messages?.strNotificationExchange);
    const allowedMarkets = useSelector((state) => state?.funds?.allowedMarkets);
    // Ameersha N : 24-11-2023 : SAT-109371 : Message Hub – End/

    const [isLocalStorageChanged, setIsLocalStorageChanged] = useState(false);
    const segmentVersionNo = useSelector((state) => state.notification.segmentVersionNo);
    const disclaimerUrl = getAppInfoData(APP_INFO_PARAMS.APP_DISCLAIMER_MODE);


    useEffect(() => {
        connectSocket();
    }, [objLoginSession]);

    //Ameersha N [This useEffects remove the modal dom after closing if its open in background] -- Start
    useEffect(() => {
        if (!Object?.values(modals)?.includes(true)) {
            let containersToBeRemoved = document.querySelectorAll('[role="dialog"]');
            if (containersToBeRemoved?.length > 0) {
                containersToBeRemoved?.forEach(dialog => {
                    dialog.style.display = 'none';
                });
            }
        }
    }, [modals]);
    //Ameersha N [This useEffects remove the modal dom after closing if its open in background] -- Start

    //Ameersha N - 05-03-2024 - BT-1207722 - Breeze -Guest User Privileges -- Start
    useEffect(() => {
        if (Object?.keys(objLoginSession)?.includes('guestMode')) {
            dispatch(updateUserId(objLoginSession?.userId));
            let localStoredTst = JSON?.parse(getDecryptLocalStorage('GUEST_TOAST'));
            if (localStoredTst === null || localStoredTst === undefined) {
                setTimeout(() => {

                    dispatch(toastConfig({ show: true, message: 'Data will be delayed by 15 Minutes', button: [{ btnName: "Ok", type: "GUEST_TOASTER", className: "btn  btn-outline-active ms-3", onClickHandler: () => { dispatch(toastConfig({})); setEncryptLocalStorage('GUEST_TOAST', JSON?.stringify(true)); } }] }));
                }, 1000);
            } else if (localStoredTst !== null && localStoredTst === true) {
                dispatch(toastConfig({}));
            }
        } else { }
    }, [objLoginSession, dispatch]);
    //Ameersha N - 05-03-2024 - BT-1207722 - Breeze -Guest User Privileges -- End
    const usageGuideUrl = getAppInfoData(APP_INFO_PARAMS.APP_BREEZE_FAQ_URL); // Ajitesh: Get faq url for breeze

    const [isExpanded, setIsExpanded] = useState(false);
    const [arrNotificationList, setArrNotificationList] = useState([
        {
            id: 1,
            content: "FAQ"
        },
        // {
        //     id: 3,
        //     content: "Privacy Policy",
        // },
        {
            id: 4,
            content: 'Terms of Use',
        },
        // {
        //     id: 5,
        //     content: 'Keyboard Shortcuts',
        // },
        // {
        //     id: 6,
        //     content: "Walkthrough",
        // },
        {
            id: 7,
            content: 'About Us',
        },
        {
            id: 8,
            content: 'Contact Us',
        }]);

    //Ameersha N -12-12-2023 - BREEZE - BT-95888 -Create Watchlist -Start
    useEffect(() => {
        if (pathname !== LOCATIONS.WATCHLIST) {
            dispatch(updateHoldingsWatchlist(false));
        } else { }
    }, [pathname]);
    //Ameersha N -12-12-2023- BREEZE - BT-95888 -Create Watchlist -End

    const iconForHeader = (menuName) => {
        if (menuName === "Dashboard") {
            return 'icon-dashboard';
        } else if (menuName === "Watchlist") {
            return 'icon-watchlist';
        } else if (menuName === 'Portfolio') {
            return 'icon-portfolio';
        } else if (menuName === "Orders") {
            return 'icon-orders';
        } else {
            return '';
        }
    };
    //Maaz A : 30-08-2023 : BT-116689 - Breeze - Create Dynamic Menu - Start
    const arrMainMenus = useMemo(() => {
        if (objMainMenu?.items?.length > 0) {
            return objMainMenu.items.map(objMenu => {
                return { id: objMenu?.id, name: objMenu?.displayName, route: objMenu?.menuUrl };
            });
        } else {
            return [];
            // dynamic menu from global var
        }
    }, [objMainMenu]);
    //Maaz A : 30-08-2023 : BT-116689 - Breeze - Create Dynamic Menu - End


    //Ameersha N - 05-03-2024 - BT-1207722 - Breeze -Guest User Privileges -- Start
    const hanldeLinkClick = useCallback((event, eachItem) => {
        //Ameersha N - 02-09-2025 Added if condition as when allowedMarkets array is empty full app reloading ;Happening for marwadi -- Start
        if (allowedMarkets?.length) dispatch(updateActiveMarket(allowedMarkets[0]));
        //Ameersha N - 02-09-2025 Added if condition as when allowedMarkets array is empty full app reloading ;Happening for marwadi -- End
        if (isUserIsAGuest(eachItem?.name)) event?.preventDefault();

    }, [allowedMarkets, dispatch]);

    //Ameersha N - 05-03-2024 - BT-1207722 - Breeze -Guest User Privileges -- End



    //Prachi Tawde : 03-07-2023 : BT-108578 -  Breeze - Quick user switch - Start
    const otherProfiles = useMemo(() => {
        if (userDetails?.length) {
            const currentSession = JSON.parse(getStorageWithMultiTabCheck(LOCAL_STORAGE_KEYS.USER_ACTIVE_SESSION));
            const otherProfiles = userDetails?.filter(user => user?.userId !== currentSession?.data?.user_id);
            return otherProfiles;
        }
        else {
            return [];
        }
    }, [userDetails]);

    //Vaibhav Singh : BT-109371: 17-10-2023: API Calls when page is loaded commented as of now:Start
    useEffect(() => {

        if (!apiFired) {
            setApiFired(true);
            if (arrMessages?.length <= 0) {
                dispatch(getMessages(objLoginSession?.data?.user_id, objLoginSession?.data?.others?.groupId, MESSAGE_HUB.USER_TYPE, MESSAGE_HUB.DEVICE_TYPE, MESSAGE_HUB.SITEMPLATE, MESSAGE_HUB.RECORD_COUNT));
            }
            if (arrBroker?.length <= 0) {
                dispatch(getMessagesBroker({ pageNo: 1 }));
            }
            if (arrOrders?.length <= 0) {
                dispatch(getMessagesOrders({ pageNo: 1 }));
                setOrdersPageNo(prev => prev + 1);
            }
            if (arrNse?.length <= 0) {
                dispatch(getMessagesNse(EXCHANGE_NAME_API.NSE_EQ_API, {
                    noofhrs: 1,
                    pageNo: 1,
                    pageSize: DEFAULT_PAGE_SIZE.EXCHANGE_MESSAGES_PAGE_SIZE
                }));
            }
        }

    }, [objLoginSession, apiFired]);

    // Deepti B: 189628 fetching broker messages on notification click start
    useEffect(() => {
        if (notificationShowPopover) {
            dispatch(getMessages(objLoginSession?.data?.user_id, objLoginSession?.data?.others?.groupId, MESSAGE_HUB.USER_TYPE, MESSAGE_HUB.DEVICE_TYPE, MESSAGE_HUB.SITEMPLATE, MESSAGE_HUB.RECORD_COUNT));
            dispatch(getMessagesBroker({ pageNo: 1 }));
        } else {
            handleNotification('broker');
        }
    }, [notificationShowPopover]);
    // Deepti B: 189628 fetching broker messages on notification click end
    //Vaibhav Singh : BT-109371: 17-10-2023: API Calls when page is loaded commented as of now: End
    //Prachi Tawde : 03-07-2023 : BT-108578 -  Breeze - Quick user switch - End

    useEffect(() => {
        if (userPreference?.length) {
            const sortedUsers = [...userPreference].sort((a, b) => new Date(b.updatedAt) - new Date(a.updatedAt));
            let image = '';
            if (sortedUsers[0]?.sProfilePicPath) {
                image = sortedUsers[0]?.sProfilePicPath + new Date().getTime().toString();
            }
            setCurrentPreference({ ...sortedUsers[0], sProfilePicPath: image });
        }
    }, [userPreference]);

    //Ameersha N -- This will load local indices from local storage if not exists loads common indices -- Start
    useEffect(() => {
        dispatch(getAndLoadLocalIndicesOnLoad());
    }, [dispatch]);
    //Ameersha N -- This will load local indices from local storage if not exists loads common indices -- End

    // const handleStateTypeahedChange = (selected) => {
    //     setStateSelected(selected);

    //     if (selected.length === 0) {
    //         cityTypeaheadRef.current.clear();
    //         cityTypeaheadRef.current.blur();
    //         setCitySelected("");
    //     } else {
    //     }
    // };
    // const handleChange = useCallback((e) => {

    //     if (e.target.name === 'userPhoneNumber') {
    //         const numericValue = e.target.value.replace(/[^0-9]/g, '');
    //         setRegistration(prev => {
    //             return { ...prev, [e.target.name]: numericValue.slice(0, LOGIN_CONSTANTS.MOBILE_NUMBER_LENGTH) };
    //         });
    //     } else if (e.target.name != 'userPhoneNumber') {
    //         setRegistration(prev => {
    //             return { ...prev, [e.target.name]: e.target.value };
    //         });
    //     }
    // }, []);

    const updateLtpObjectForHeaderIndices = (objData, data) => {
        return {
            ...objData,
            LTP: data[TL_INDEX?.LAST_TRADE_PRICE],
            netChange: data[TL_INDEX?.ABSOLUTE_NET_CHANGE_FROM_PRE_CLOSE],
            netChangeIndicator: data[TL_INDEX?.NET_CHANGE_FROM_PRE_CLOSE] || 0,
            lastTradeTime: data[TL_INDEX?.LAST_TRADE_TIME],
        };
    };




    const handleIndicesLiveData = useCallback((arrLiveData) => {
        setHeaderIndices(prevState => {

            let prevStateCopy = prevState;
            let tlKey = arrLiveData[TL_INDEX.SEGMENT_ID] + '_' + arrLiveData[TL_INDEX.TOKEN];
            let abc = prevStateCopy[tlKey];
            if (abc && Object?.keys(abc)?.length > 0) {
                let copyObjet = {
                    ...abc,
                    LTP: arrLiveData[TL_INDEX?.LAST_TRADE_PRICE],
                    netChange: arrLiveData[TL_INDEX?.ABSOLUTE_NET_CHANGE_FROM_PRE_CLOSE],
                    netChangeIndicator: arrLiveData[TL_INDEX?.NET_CHANGE_FROM_PRE_CLOSE] || 0,
                    lastTradeTime: arrLiveData[TL_INDEX?.LAST_TRADE_TIME],
                };
                prevStateCopy[tlKey] = copyObjet;
            }
            return { ...prevStateCopy };

        });
    }, []);

    useWFHMessages('touchline', (e) => {
        let data = [...e.detail];
        handleIndicesLiveData(data);
    });
    //Functionality to check the lastik regularly by polling --start
    const [shouldStop, setShouldStop] = useState(false);
    const handleIndicesSubScrips = useCallback(() => {
        const objLastTickData = dispatch(getWfhTouchlineLastTick());
        let arrKeyWithSubscriptionCount = Object?.keys(objTokenWiseTLSubscripionCounter);
        const arrLastiTikcKeys = Object.keys(objLastTickData);
        if (headerIndicesFromRedux?.length > 0 && arrKeyWithSubscriptionCount?.length > 0) {
            let arrStillsubScription = [];
            let arrStillLastiData = [];
            headerIndicesFromRedux?.forEach((eachHeader) => {
                let eachIndicesKey = eachHeader?.nMarketSegmentId + '_' + eachHeader?.nToken;
                // checking header indcies scrips subscription is gone or not if not sending subscription
                if (!arrKeyWithSubscriptionCount?.includes(eachIndicesKey)) {
                    arrStillsubScription.push({
                        exchangeId: eachHeader?.nMarketSegmentId,
                        token: eachHeader?.nToken,
                        isSubscribe: true
                    });
                }
                // checking indices scrips ar epresent in lasttick
                if (arrLastiTikcKeys?.includes(eachIndicesKey)) {
                    arrStillLastiData.push(objLastTickData[eachIndicesKey]);
                }
            });
            if (arrStillsubScription?.length > 0) {
                sendTouchlineRequest(arrStillsubScription);
            }
            if (arrStillLastiData?.length > 0 && headerIndicesFromRedux?.length > 0) {
                arrStillLastiData?.forEach((eachLastiTikcData) => {
                    handleIndicesLiveData(eachLastiTikcData);
                });
                // if lastitik is handle then stopping polling
                setShouldStop(true);
            }
        }
    }, [dispatch, headerIndicesFromRedux, handleIndicesLiveData]);
    //Functionality to check the lastik regularly by polling --End


    //Polling hook i used to check the lastitk of header indcies regularly --- Start
    const { stopPolling } = usePolling(handleIndicesSubScrips, { interval: 2000, type: "short" });
    //Polling hook i used to check the lastitk of header indcies regularly --- End

    //This will stop the polling if the conditionis met --Start
    useEffect(() => {
        if (shouldStop) {
            stopPolling();
        }
    }, [shouldStop, stopPolling]);
    //This will stop the polling if the conditionis met --End














    //This will stop the polling if the conditionis met --End

    // const handleSubmit = useCallback((e) => {
    //     e.preventDefault();

    //     dispatch(userRegister
    //         ({
    //             api_key: config.Wave.ApiKey,
    //             user_name: e.target.userName.value,
    //             mobile_number: e.target.userPhoneNumber.value,
    //             state: stateSelected[0],
    //             city: citySelected[0],
    //             email_id: e.target.userEmail.value,
    //             plugin_info: {
    //                 DevicePlatform: "web",
    //                 AppName: "Breeze",
    //             }
    //         }));

    // }, [dispatch, stateSelected, citySelected]);

    useEffect(() => {
        if (registration['userEmail']?.length && registration['userName']?.length && registration['userPhoneNumber']?.length === 10 && stateSelected.length > 0 && citySelected.length > 0) {
            setBDisableEKycButton(false);
        } else {
            setBDisableEKycButton(true);
        }
    }, [registration, stateSelected, citySelected]);

    useEffect(() => {
        const cityOption = statesCities && statesCities?.filter((item) =>
            item.name.includes(stateSelected[0]));
        const arrCityData = cityOption && cityOption[0]?.cities?.map((item) => item.name);
        setCityOptionData(arrCityData);
    }, [stateSelected, statesCities]);
    //PrachiTawde : 05-05-2023 : BT-109047 -  Breeze- User Profile - End

    //Prachi Tawde : 04-07-2023 : BT-108578 -  Breeze - Quick user switch - Start
    useEffect(() => {
        setIsLocalStorageChanged(true);
    }, [objLoginSession?.data]);


    useEffect(() => {
        if (isLocalStorageChanged) {
            const arrNewUsers = [];
            let storage = localStorage.getItem('MULTI_TAB') == 'true' ? sessionStorage : localStorage;
            for (let i = 0; i < storage.length; i++) {
                if (storage.key(i).startsWith(LOCAL_STORAGE_KEYS.USER_DETAILS)) {
                    let key = storage.key(i);
                    let value = getStorageWithMultiTabCheck(key);
                    if (value) {
                        value = JSON.parse(value);
                        if (value?.lastLoginTime) {
                            arrNewUsers[arrNewUsers.length] = value;
                        }
                        else { }
                    }
                }
            }
            if (arrNewUsers?.length > 0) {
                const sortedUsers = [...arrNewUsers].sort((a, b) => new Date(b.lastLoginTime?.replace(/-/g, '/')) - new Date(a.lastLoginTime?.replace(/-/g, '/')));
                setUserDetails(sortedUsers);
            }
            else { }
            setIsLocalStorageChanged(false);
        }
    }, [isLocalStorageChanged, localStorage]);
    //Prachi Tawde : 04-07-2023 : BT-108578 -  Breeze - Quick user switch - End


    const handleClickIndiceCard = useCallback(async (item, event) => {
        event?.preventDefault();
        // event?.stopPropagation();// Azeem K :13-08-2024 : commented it because it effecting on watchlist popover
        if (!('isGlobal' in item)) {
            const arrScrips = [{ mkt: getApiExchangeNameFromMktSegId(getMktSegIdFromMappedMktSegId(item?.nMarketSegmentId)), token: item?.nToken }];
            const objResp = await getScripbyTokenAndMktSegId(arrScrips);
            const gridFormatData = convertScripResponseWatchlistGrid(objResp?.data?.result);
            let selectedScrips = gridFormatData[0];
            if (selectedScrips?.length > 0) {
                gridFormatData[0].push(item?.sIndexDesc);
                selectedScrips[WATCHLIST_GRID_INDEX?.SYMBOL] = item?.sIndexDesc;
            } else {

                selectedScrips = [];
                let newArray = new Array(Object?.keys(WATCHLIST_GRID_INDEX)?.length)?.fill('');
                selectedScrips = newArray;
                selectedScrips[WATCHLIST_GRID_INDEX?.SYMBOL] = item?.sIndexDesc;
                selectedScrips[WATCHLIST_GRID_INDEX?.EXCHANGE] = getApiExchangeNameFromMktSegId(item?.nMarketSegmentId)?.split('_')[0];
            }
            //Prachi T - 14-12-2023 :- BT-104813 -- Dashboard Indices - Start
            if (DEFAULT_FAVOURITE_INDICES.includes(`${item?.nMarketSegmentId}_${item?.nToken}`)) {
                selectedScrips[WATCHLIST_GRID_INDEX?.SEGMENT_ID_TOKEN] = `${item?.nMarketSegmentId}_${item?.nToken}`;
                selectedScrips[WATCHLIST_GRID_INDEX.SEGMENT_ID] = item?.nMarketSegmentId;
            }
            //Prachi T - 14-12-2023 :- BT-104813 -- Dashboard Indices - End
            selectedScrips[WATCHLIST_GRID_INDEX.TOKEN] = item?.nToken; //Prachi T - 27-11-2023 :- BT-104813 -- Dashboard Indices
            dispatch(setScripOverviewData(selectedScrips));
            dispatch(setIndiceOverviewData(item));
            dispatch(setIsIndicesOverview(true));
            dispatch(handleModalData({ header: true, item: item })); // Hari k:22-03-2024: BT- 108447:create watchlist from list
        }
        else { }
    }, [dispatch]);

    useEffect(() => {
        if (isIndicesOverview) {
            dispatch(handleModal([{ 'MARKET_OVERVIEW_MODAL': true }]));
        }
    }, [isIndicesOverview]);

    // Parshva S: 30/04/2024 : Added app version number - Start
    useEffect(() => {
        let verNo = getAppInfoData(APP_INFO_PARAMS.APP_BREEZE_VERSION, APP_INFO_DEFAULT_VALUES.VERSION_NUMBER);
        setVersionNumber(verNo);
    }, [appInfo]);
    // Parshva S: 30/04/2024 : Added app version number - End

    //PrachiTawde : 08-06-2023 : BT-110222 -  Breeze- Having Problem? Share with us - Start
    //BT-107437: Functional Implementation InvestMents : Vaibhav Singh : 21-08-2023 : Implemented Value for Dyanamic URl
    const getFeedbackURL = useCallback((urlData) => {
        let url;
        let params = "";
        if (urlData !== '' && urlData !== undefined && urlData !== null) {
            url = urlData?.split('?')[0];
            params = urlData?.split('?')[1];
            if (params?.indexOf(DYANMIC_URL_CONSTANTS.UID) > -1) {
                params = params?.replace(DYANMIC_URL_CONSTANTS.UID, objLoginSession?.data?.user_id);
            }

            if (params?.indexOf(DYANMIC_URL_CONSTANTS.OCTOKEN) > -1) {
                params = params?.replace(DYANMIC_URL_CONSTANTS.OCTOKEN, objLoginSession?.data?.others?.ocToken);
            }

            if (params?.indexOf(DYANMIC_URL_CONSTANTS.GROUPCODE) > -1) {
                params = params?.replace(DYANMIC_URL_CONSTANTS.GROUPCODE, objLoginSession?.data?.others?.groupCode);
            }

            if (params?.indexOf(DYANMIC_URL_CONSTANTS.GROUPID) > -1) {
                params = params?.replace(DYANMIC_URL_CONSTANTS.GROUPID, objLoginSession?.data?.others?.groupId);
            }

            if (params?.indexOf(DYANMIC_URL_CONSTANTS.DEALERCODE) > -1) {
                params = params?.replace(DYANMIC_URL_CONSTANTS.DEALERCODE, objLoginSession?.data?.others?.userCode);
            }

            if (params?.indexOf(DYANMIC_URL_CONSTANTS.MANAGERID) > -1) {
                params = params?.replace(DYANMIC_URL_CONSTANTS.MANAGERID, objLoginSession?.data?.others?.managerIP);
            }

            if (params?.indexOf(DYANMIC_URL_CONSTANTS.USERCODE) > -1) {
                params = params?.replace(DYANMIC_URL_CONSTANTS.USERCODE, objLoginSession?.data?.others?.userCode);
            }
        }
        else {
            url = "";
        }
        if (params) {
            return url += '?' + params;;
        }
        else {
            return url;
        }
    }, [objLoginSession]);
    //PrachiTawde : 08-06-2023 : BT-110222 -  Breeze- Having Problem? Share with us -End

    //PrachiTawde : 06-09-2023 : BT-107252 -  Breeze – Rate us & Feedback - Start
    //PrachiTawde : 08-06-2023 : BT-110222 -  Breeze- Having Problem? Share with us
    const feedbackURL = useMemo(() => {
        const url = getAppInfoData(APP_INFO_PARAMS.APP_FEEDBACK_MAIL);
        let trimmedUrl = url.trim();
        validateEmail(trimmedUrl);

        if (validateEmail(trimmedUrl)) {
            return `mailto:${trimmedUrl}`;
        } else {
            return getFeedbackURL(trimmedUrl);
        }
    }, [appInfo, getFeedbackURL]);
    //PrachiTawde : 08-06-2023 : BT-110222 -  Breeze- Having Problem? Share with us
    //PrachiTawde : 06-09-2023 : BT-107252 -  Breeze – Rate us & Feedback - End






    const navigate = useNavigate();


    const handleViewProfile = () => {
        let objResp = _userType(userInfo?.guestMode);
        if (objResp?.status) {
            dispatch(handleModal([{ 'GUEST_USER_PROFILE_MODAL': true }]));
        }
        else {
            dispatch(handleModal([{ 'USER_PROFILE_MODAL': true }]));
        }
    };

    const handleAboutUs = () => {
        const hasAboutUsData = (typeof aboutUs === "string" && aboutUs.trim().length > 0) || (Array.isArray(aboutUs) && aboutUs.length > 0);
        if (hasAboutUsData) {
            dispatch(handleModal([{ "ABOUT_US_MODAL": true }]));
        }
        else {
            handleOpenMode(aboutusInfo);
        }
    };

     const handleDisclaimer = () => {
        const hasDisclaimerData =
          (typeof disclaimer === "string" && disclaimer.trim().length > 0) ||
          (Array.isArray(disclaimer) && disclaimer.length > 0);
        if (hasDisclaimerData) {
          dispatch(handleModal([{ "DISCLAIMER_MODAL": true }]));
        }
        else {
          handleOpenMode(disclaimerInfo);
        }
      };

    const helpHandler = (id) => {
        switch (id) {
            case 1:
                // Ajitesh: Opens Breeze FAQ URL in new window
                window.open(`${usageGuideUrl}?tenant=${config.TenantId}&userId=${userIdForFaq}`, "_blank");
                break;
            case 3:
                handleDisclaimer();
                break;
            case 4: dispatch(getTermsAndCondition()).then((res) => {
                if (res?.length > 0) {
                    dispatch(handleModal([{ "TERMS_CONDITION_MODAL": true }]));
                }
                else {
                    dispatch(handleModal([{ "TERMS_CONDITION_MODAL": false }]));
                }
            }).catch((err) =>
                console.error(err)
            );
                break;
            case 5: dispatch(handleModal([{ "KEYBOARD_SHORTCUTS": false }]));
                break;
            case 6: dispatch(walkthroughPopoversContentUpdate(pathname.split('').slice(1).join('').toUpperCase()));
                break;
            case 7:
                handleAboutUs();
                break;
            case 8: dispatch(handleModal([{ "CONTACT_US": true }]));
                break;
            default:
                break;
        }
    };



    const arrExchangeType = useMemo(() => objLoginSession?.data?.exchanges?.filter(value => value !== ''), [objLoginSession]);

    useEffect(() => {

        let arrExchangeType = [];

        if (objLoginSession?.data?.exchanges) {
            for (let i = 0; i < objLoginSession?.data?.exchanges?.length; i++) {
                arrExchangeType.push({ id: [i], value: [objLoginSession?.data?.exchanges[i]], name: Object.values(EXCHANGE_NAME_NOTIFICATION)[i] });
            }
        }
    }, [objLoginSession?.data?.exchanges]);

    // Ameersha N : 24-11-2023 : SAT-109371 : Message Hub – Start/
    useEffect(() => {
        if (arrExchangeType && arrExchangeType?.length > 0) {
            if (notificationExchange?.length <= 0) {
                dispatch(updateStrExchangeNotification(arrExchangeType[0]));
            } else {
                dispatch(updateStrExchangeNotification(notificationExchange));
            }

        } else { }
    }, [arrExchangeType, notificationExchange]);
    // Ameersha N : 24-11-2023 : SAT-109371 : Message Hub – End/

    useEffect(() => {
        if (notificationShowPopover) {
            if (notificationExchange !== 'MUTUAL_FUND') {
                dispatch(getMessagesNse(notificationExchange, {
                    noofhrs: 1,
                    pageNo: 1,
                    pageSize: DEFAULT_PAGE_SIZE.EXCHANGE_MESSAGES_PAGE_SIZE
                }));
            } else {
                dispatch(MessagesNse([]));
            }
        }
    }, [notificationExchange]);

    // Ameersha N : 24-11-2023 : SAT-109371 : Message Hub – Start/
    useEffect(() => {
        if (strNotificationActiveChip === 'broker' && isReachedLimit === true) {
            setBrokerPageNo(prev => prev - 1);
        } if (strNotificationActiveChip === 'order' && isReachedLimit === true) {
            setOrdersPageNo(prev => prev - 1);
        } if (strNotificationActiveChip === 'exchange' && isReachedLimit === true) {
            setNsePageNo(prev => prev - 1);
        }
    }, [isReachedLimit, strNotificationActiveChip]);
    // Ameersha N : 24-11-2023 : SAT-109371 : Message Hub – End/

    // Ameersha N : 24-11-2023 : SAT-109371 : Message Hub – Start/
    const handleNotification = (name, value) => {
        dispatch(updateNotificationsCountStatus()); // Hari K:dispatching action to change notification count status
        switch (name) {
            case 'broker':
                dispatch(updateMsgActiveChip(name));
                dispatch(setNotifCountBroker(0));
                break;
            case 'order':
                dispatch(updateMsgActiveChip(name));
                dispatch(setNotifCountOrder(0));
                dispatch(getMessagesOrders({ pageNo: 1 }));
                break;
            case 'exchange':
                dispatch(updateMsgActiveChip(name));
                dispatch(updateStrExchangeNotification(value));
                dispatch(setNotifCountExchange(0));
                break;
            default:
                break;
        }
    };
    // Ameersha N : 24-11-2023 : SAT-109371 : Message Hub – End/

    const notificationPopover = () => {
        setNotificationShowPopover(!notificationShowPopover);
        dispatch(setNotifCountBroker(0));
    };

    const handleDoneMessage = () => new Promise((resolve) => {
        setSpinner(false);
        setbIsDone(true);
        setTimeout(() => {
            // setbIsDone(false);
            resolve();
        }, 3000);
    });

    //Prachi Tawde : 03-07-2023 : BT-108578 -  Breeze - Quick user switch - Start
    const handleUseAnotherAccount = () => {
        getEvent("LOGIN_SWITCHUSER");
        dispatch(resetAllAuthData());
        removeStorageWithMultiTabCheck(LOCAL_STORAGE_KEYS.USER_ACTIVE_SESSION);
        navigate('/');
        dispatch(updateMpinEnabled(false));
        setStorageWithMultiTabCheck(LOCAL_STORAGE_KEYS.MPIN_ENABLE, false);
        navigate('/');
    };

    const handleUserSwitch = (user) => {
        setStorageWithMultiTabCheckWithoutEncryption("ACTIVE_USER", user?.loginByAliasId ? user?.aliasId?.toUpperCase() : user?.userId?.toUpperCase());
        const userStatus = getUserStatus(user?.data?.login_time);
        if (userStatus) {
            setSpinner(true);
            const userDetail = JSON.parse(getStorageWithMultiTabCheck(`${LOCAL_STORAGE_KEYS.USER_DETAILS}_${user?.userId}`));
            const now = new Date();
            const options = { year: 'numeric', month: 'short', day: '2-digit', hour: '2-digit', minute: '2-digit', second: '2-digit', hour12: false };
            const formattedTime = now.toLocaleString('en-US', options);

            const activeSession = { ...objLoginSession, data: { ...userDetail?.data }, lastLoginTime: formattedTime };
            dispatch(userSwitch(activeSession));
            onUserLoggedInActiveSession(activeSession, dispatch, handleDoneMessage, appInfo, user?.userId);
            setDoneMessage('User Switched successfully!');
        }
        else {
            dispatch(resetAllAuthData());
            removeStorageWithMultiTabCheck(LOCAL_STORAGE_KEYS.USER_ACTIVE_SESSION);
            setStorageWithMultiTabCheck('SWITCH_TO_USER_ID', user?.userId);
            navigate('/');
        }
    };
    const handleOpenProfileSettings = () => {
        dispatch(handleModal([{ 'PROFILE_SETTINGS_MODAL': true }]));
    };

    const getUserStatus = (lastLoginTime) => {
        const currentDate = new Date();
        const loginDate = new Date(lastLoginTime);
        if (loginDate) {
            return compareDates(currentDate, loginDate);
        }
        else {
            return false;
        }

    };
    //Prachi Tawde : 03-07-2023 : BT-108578 -  Breeze - Quick user switch - End
    const [spin, setSpin] = useState(false);
    useEffect(() => {
        setSpin(true);
        setTimeout(() => {
            setSpin(false);
        }, 1000);
    }, []);

    const indices = useMemo(() => {
        if (Object?.values(headerIndices)?.length > 0) {
            return Object?.values(headerIndices);
        } else {
            return [];
        }
    }, [headerIndices]);
    {/* BREEZE-4265 : Ravi R : 05-03-2025: Display segment wise version number: Modal function */ }
    const handleSegmentWiseVersion = useCallback(() => {
        if (!segmentVersionNo) {
            dispatch(updateIsLoading(true));
            dispatch(handleModal([{ "SEGMENT_WISE_VERSION": true }]));
            dispatch(segmentWiseVersion()).then(() => {
                dispatch(updateIsLoading(false));
            }).catch((error) => {
                dispatch(updateIsLoading(false));
            });
        }
        else {
            dispatch(handleModal([{ "SEGMENT_WISE_VERSION": true }]));
        }

    }, [segmentVersionNo]);


    let activeUser = getStorageWithMultiTabCheckWithoutEncryption('ACTIVE_USER');


    const handleRedirect = (userName) => {
        const currentUrl = new URL(window.location.href);
        currentUrl.searchParams.set('user', userName);
        window.open(currentUrl.toString(), '_blank');
    };

    const handleFunds = () => {
        dispatch(handleModal([{ "FUNDS_MODAL": true }]));
    };

    return (
        pathname !== "/onboarding" ?
            <>
                <DevToolsMsgModal />
                {/* {setting && <Settings setSetting={setSetting} />} */}

                <GuestUserRestrictionModal />

                {/* // Ameersha N : 17-11-2023 : BT-116461 Breeze - Addendum and Notices --Start */}
                <AddEndumAndNoticesModal />
                {/* // Ameersha N : 17-11-2023 : BT-116461 Breeze - Addendum and Notices --End */}

                <LoginLoader spinner={spinner} spinnerContent={"Switching User!"} />
                <DoneOverlay bIsDone={bIsDone} doneOverlayContent={doneMessage} class={'z-index-xl'} />
                { /*  Hari K :06-11-2023: BT-109371 message hub - issue: passing props to notification modal -start */}
                <NotificationModal brokerPageNo={brokerPageNo} ordersPageNo={ordersPageNo} NsePageNo={NsePageNo} setBrokerPageNo={setBrokerPageNo} setOrdersPageNo={setOrdersPageNo} setNsePageNo={setNsePageNo} handleNotification={handleNotification} notificationExchange={notificationExchange} arrExchangeType={arrExchangeType} notificationActiveChip={strNotificationActiveChip}
                    isExpanded={isExpanded} setIsExpanded={setIsExpanded} />
                { /*  Hari K :06-11-2023: BT-109371 message hub - issue: passing props to notification modal -end */}

                <Container data-testid="header-indices-container" fluid className='sticky-top header-wrapper d-none d-lg-block p-0'>
                    {isDashMenu === true ? <DashMenu toggleThemeBtn={toggleThemeBtn} setToglThemeBtn={setToglThemeBtn} /> : null}
                    <div className='d-flex h-100 col-g-5 gap-xxl-3'>
                        <div className='d-flex justify-content-start align-items-center'>
                            {/* <div className='btn-back-to-home'>
                            <span class="icon-16 icon-backward-arrow icon-light d-flex flex-shrik-0"></span>
                            <span class="font-medium font-size1 line-height-1">Back</span>
                          </div>                            */}
                            <div className='logo-container ps-2 ps-xl-3'>
                                <div className='logo img-fluid'></div>
                            </div>
                        </div>
                        <div className='d-flex justify-content-end align-items-center flex-grow-1 bdr-rgt mx-1 mx-xl-2'>
                            <div className='menu-wrap d-flex justify-content-end gap-1 gap-xl-2'>
                                {
                                    arrMainMenus?.length > 0 && arrMainMenus?.map((objMenu, i) => (
                                        <div key={i} className='menu'>
                                            <div className={`menu-item ${pathname === objMenu?.route ? 'active' : ''}`}>
                                                <Link data-testid={`nav-menu-${objMenu?.name.toLowerCase()}`} className='d-flex align-items-center' onClick={(e) => hanldeLinkClick(e, objMenu)} to={objMenu?.route}>
                                                    {objMenu?.name ? <div className={`icon-14 menu-icon-color me-2 ${iconForHeader(objMenu?.name)}`}></div> : null}
                                                    <div>{objMenu?.name}</div>
                                                </Link>
                                            </div>
                                        </div>
                                    ))
                                }
                            </div>
                        </div>
                        <div className='d-flex justify-content-end'>
                            <div data-testid="header-indices-wrap" className='indices-wrap d-flex align-items-center'>
                                {spin ?
                                    <div className='skeleton-loader-wrapper'>
                                        <Container className='p-0 px-4'>
                                            <Row className='g-0 d-flex align-items-center'>
                                                <Col data-testid="header-indices" md={4} className='indices px-2'>
                                                    <Row className='g-0'>
                                                        <Col className='py-2'>
                                                            <div className='p-0 line-height-1'>
                                                                <Skeleton count={1} height={15} width={120} />
                                                                <Skeleton count={1} height={12} width={100} />
                                                                <Skeleton count={1} height={10} width={75} />
                                                            </div>
                                                        </Col>
                                                    </Row>
                                                </Col>
                                                <Col md={4} className='indices px-2'>
                                                    <Row className='g-0'>
                                                        <Col>
                                                            <div className='p-0 line-height-1'>
                                                                <Skeleton count={1} height={15} width={120} />
                                                                <Skeleton count={1} height={12} width={100} />
                                                                <Skeleton count={1} height={10} width={75} />
                                                            </div>
                                                        </Col>
                                                    </Row>
                                                </Col>
                                                <Col md={4} className='indices px-2'>
                                                    <Row className='g-0'>
                                                        <Col>
                                                            <div className='p-0 line-height-1'>
                                                                <Skeleton count={1} height={15} width={120} />
                                                                <Skeleton count={1} height={12} width={100} />
                                                                <Skeleton count={1} height={10} width={75} />
                                                            </div>
                                                        </Col>
                                                    </Row>
                                                </Col>
                                            </Row>
                                        </Container>
                                    </div>
                                    :
                                    <div className='d-flex align-items-center gap-1'>
                                        {!spin && indices?.length > 0 &&
                                            indices?.map((arr, i) => (
                                                <div key={i} className='indices cursor-pointer' onClick={(e) => { handleClickIndiceCard(arr, e); }}>
                                                    <div data-testid="header-indices-scrip-name" className='font-medium indices-scripname color-text text-nowrap'>{arr?.sIndexDesc?.length > 12 ? `${arr?.sIndexDesc.slice(0, 12)}...` : arr?.sIndexDesc}</div>
                                                    <div data-testid="header-indices-ltp" className={`font-medium indices-ltp color-text text-nowrap ${arr?.netChangeIndicator > 0 ? 'color-positive' : 'color-negative'}`}>{arr?.LTP || 0}</div>
                                                    <div data-testid="header-indices-change-percentage" className={`font-semibold indices-changepercent color-text text-nowrap ${arr?.netChangeIndicator > 0 ? 'color-positive' : 'color-negative'}`}>{arr?.netChange || 0} ({arr?.netChangeIndicator}%)</div>
                                                </div>
                                            ))
                                        }
                                        <div className='justify-content-center'>
                                            <BzToolTip placement='bottom' TooltipMsg='Settings'>
                                                <div data-testid='header-indices-settings-icon' className='icon-20 icon-dark icon-sort-down' onClick={() => {
                                                    dispatch(handleModal([{ "HEADER_INDICES": true }]));
                                                }}>
                                                </div>
                                            </BzToolTip>
                                        </div>
                                    </div>}
                            </div>
                        </div>
                        <div className='d-flex align-items-center bdr-lft px-1 px-xl-2'>
                            <div className='shortmenu-wrap d-flex align-items-center gap-2 gap-xxl-3'>
                                { /*  Hari K :06-11-2023: BT-109371 message hub - issue: passing props to notification modal -start */}
                                <Notification brokerPageNo={brokerPageNo} ordersPageNo={ordersPageNo} NsePageNo={NsePageNo} setBrokerPageNo={setBrokerPageNo} setOrdersPageNo={setOrdersPageNo} setNsePageNo={setNsePageNo} handleNotification={handleNotification} placement={"bottom"} trigger='click' notificationShowPopover={notificationShowPopover} setNotificationShowPopover={setNotificationShowPopover} notificationExchange={notificationExchange} arrExchangeType={arrExchangeType} notificationActiveChip={strNotificationActiveChip} isExpanded={isExpanded} setIsExpanded={setIsExpanded}>
                                    { /*  Hari K :06-11-2023: BT-109371 message hub - issue: passing props to notification modal -end */}
                                    <div className='shortmenu userprofile-dropdown'>
                                        <div className='bell-icon-wrap'>
                                            <BzToolTip placement='bottom' TooltipMsg='Notification'>
                                                { /*  Ameersha N :22-11-2023: BT-109371 message hub - issue: icon color change when active notification count -Start */}
                                                <div data-testid='header-notification-icon' className={`icon-24 d-flex flex-shrink-0 ${countBroker + countExchange + countOrder !== 0 ? 'icon-blue' : 'icon-dark'} icon-bell`} onClick={notificationPopover}></div>
                                                { /*  Ameersha N :22-11-2023: BT-109371 message hub - issue: icon color change when active notification count -end */}
                                            </BzToolTip>
                                            {
                                                countBroker + countExchange + countOrder !== 0 &&
                                                <div className='sticky-notification-count'>{countBroker + countExchange + countOrder}</div>
                                            }
                                        </div>
                                    </div>
                                </Notification>
                                {/*The icons is been hide for now as there is no functionality for the same*/}
                                {/* <div className='shortmenu userprofile-dropdown'>
                                    <BzToolTip placement='bottom' TooltipMsg='Whats New'>
                                        <div className='icon-20 icon-dark icon-whatsnew'></div>
                                    </BzToolTip>
                                </div> */}
                                <BzToolTip placement='bottom' TooltipMsg='Funds'>
                                    { /*  Ameersha N :22-11-2023: BT-109371 message hub - issue: icon color change when active notification count -Start */}
                                    <div data-testid='header-notification-icon' className={`icon-24 d-flex flex-shrink-0 icon-rupee`} onClick={handleFunds}></div>
                                    { /*  Ameersha N :22-11-2023: BT-109371 message hub - issue: icon color change when active notification count -end */}
                                </BzToolTip>
                                <div className='shortmenu userprofile-dropdown'>
                                    <BzDropdown>
                                        <Dropdown.Toggle as={CustomDropdownToggle}>
                                            <BzToolTip placement='bottom' TooltipMsg='Help'>
                                                <div data-testid='header-help-icon' className='icon-24 icon-dark icon-help d-flex flex-shrink-0'></div>
                                            </BzToolTip>
                                        </Dropdown.Toggle>
                                        <Dropdown.Menu>
                                            {
                                                arrNotificationList?.map(objList =>
                                                    <Dropdown.Item data-testid={objList.content} key={objList.id} onClick={() => helpHandler(objList.id)}>
                                                        {objList.content}
                                                    </Dropdown.Item>
                                                )
                                            }
                                            <Dropdown.Item as='a' href={feedbackURL} target='_blank' className='bdr-top' aria-label=''>
                                                <div className='font-medium'>
                                                    Having problem? Share with us
                                                </div>
                                            </Dropdown.Item>
                                        </Dropdown.Menu>
                                    </BzDropdown>
                                </div>

                                <div className='shortmenu userprofile-dropdown'>
                                    <Dropdown>
                                        <Dropdown.Toggle as={CustomDropdownToggle}>
                                            <div data-testid='profile-btn' className='login-user-wrap d-flex align-items-center gap-1'>
                                                <div className='icon-24 icon-profile icon-dark d-flex flex-shrink-0'></div>
                                                <BzToolTip placement='bottom' TooltipMsg={objLoginSession?.data?.user_name} >
                                                    <div className='font-regular font-size1 color-text'>{objLoginSession?.data?.user_name?.slice(0, 7)}..</div>
                                                </BzToolTip>
                                                <div data-testid='arrow-down' className='icon-12 icon-arrowdown icon-dark flex-shrink-0 me-1'></div>
                                            </div>
                                        </Dropdown.Toggle>
                                        <Dropdown.Menu>
                                            <Dropdown.Item className='py-3 active' onClick={handleViewProfile}>
                                                <Container fluid className='p-0'>
                                                    <Row className='g-0'>
                                                        <Col md={2}>
                                                            <div className='user-profile'>
                                                                {currentPreference?.sProfilePicPath ? <img className='profile-picture rounded-circle' src={currentPreference?.sProfilePicPath} height={36} width={36} alt={objLoginSession?.data?.user_name} />
                                                                    :
                                                                    <div className='profile-picture-name'>{_getInitialsFromUserName(objLoginSession?.data?.user_name)?.data}</div>}
                                                            </div>
                                                        </Col>
                                                        <Col md={9}>
                                                            <div className='font-medium font-size6 color-text text-capitalize text-truncate'>{userInfo?.guestMode ? userInfo?.userId : objLoginSession?.data?.user_name}</div>  {/* { Shuaib P - 22-11-2023-BT-109047_Breeze-User Profile } */}
                                                            <div className='font-regular font-size1 color-subtext text-truncate'>User ID: {activeUser}</div> {/*User _ id logic */}
                                                            <div className='font-regular font-size1 color-subtext text-truncate'>Last Login: {moment(objLoginSession?.data?.login_time).format('hh:mm A ,DD/MM/YYYY')}</div>
                                                        </Col>
                                                        <Col md={1}>
                                                            <div className='icon-14 icon-arrowright icon-dark mt-2'></div>
                                                        </Col>
                                                    </Row>
                                                </Container>
                                            </Dropdown.Item>

                                            {!objLoginSession?.guestMode && !isSwitchUserDisabled ?
                                                <>
                                                    <Row className='g-0 px-2 py-2 bdr-top'>
                                                        <Col className='d-flex justify-content-between'>
                                                            <span className='font-regular font-size2 color-subtext'>Other Profiles</span>
                                                            <div className='icon-16 icon-profile-setting icon-dark' onClick={handleOpenProfileSettings}></div>
                                                        </Col>
                                                    </Row>
                                                    {/* <div onClick={handleRedirect.bind(this,otherProfiles[0]?.userId)}>{'=>'}</div> */}
                                                    {
                                                        otherProfiles?.map((user, i) =>
                                                            <Dropdown.Item key={i} onClick={handleUserSwitch.bind(this, user)}>
                                                                <Row className='g-0'>
                                                                    <Col md={12} className='d-flex justify-content-start align-items-start'>
                                                                        <div className={`username user${i + 1}`}>{user?.userName?.length ? user?.userName[0] : ''}</div>  {/* set conditional classes for diff background - user1, user2, user3 */}
                                                                        <div className='d-flex flex-column mx-2'>
                                                                            <div className='font-medium font-size2 color-text'>{user.userName}</div>
                                                                            <div className='d-flex align-items-center'>
                                                                                <span className='font-regular font-size1 color-subtext text-truncate'>User ID: </span> {/*User _ id logic */}
                                                                                <span className='font-regular font-size1 color-subtext text-truncate'>{user?.loginByAliasId ? user?.aliasId : user?.userId}</span> {/*User _ id logic */}
                                                                            </div>
                                                                        </div>
                                                                        <div className='d-flex align-items-center ms-auto'>
                                                                            <div className={`allocate-dot ${getUserStatus(user?.data?.login_time) ? 'light-green-allocation' : 'grey-allocation'}`}>&nbsp;</div>    {/* set conditional classes - light-green-allocation and grey-allocation */}
                                                                            <div className='font-regular font-size2 color-subtext ms-2'>{getUserStatus(user?.data?.login_time) ? 'Active' : 'Away'}</div>
                                                                        </div>
                                                                    </Col>
                                                                </Row>
                                                            </Dropdown.Item>
                                                        )
                                                    }

                                                    <Dropdown.Item className='g-0 bdr-btm' onClick={handleOpenProfileSettings}>
                                                        <Row className='g-0'>
                                                            <Col className='d-flex justify-content-start align-items-center'>
                                                                <div className='icon-12 icon-add icon-dark me-2'></div>
                                                                <div data-testid='add-account-from-profile-settings' className='font-regular font-size2 color-text p-t-3'>Add another account</div>
                                                            </Col>
                                                        </Row>
                                                    </Dropdown.Item>
                                                </> : null}

                                            {/*Rate us & Feedback Menu Removed as of now by SumitG*/}
                                            {/* {feedbackURL && <Dropdown.Item className='g-0' as='a' href={feedbackURL} target={getUrlTarget()}>
                                            <Row className='g-0'>
                                                <Col className='d-flex justify-content-start align-items-center'>
                                                    <div className='icon-16 icon-rating icon-dark me-2'></div>
                                                    <div className='font-regular font-size2 color-text p-t-3'>Rate us &amp; Feedback</div>
                                                </Col>
                                            </Row>
                                        </Dropdown.Item>} */}

                                            <Row className='g-0 px-2 py-2 bdr-top'>
                                                <Col className='d-flex justify-content-end align-items-center'>
                                                    {/* BREEZE-4265 : Ravi R : 05-03-2025: Display segment wise version number: anchor link for modal */}
                                                    <div className='font-regular font-size3 color-subtext d-flex align-items-center'><span className='p-t-3'>Version {versionNumber}</span> {!objLoginSession?.guestMode ? <span data-testid='version-no-arrow-icon' className='icon-14 icon-arrowright icon-dark flex-shrink-0 mx-1 pt-1' onClick={handleSegmentWiseVersion}></span> : null}</div>
                                                </Col>
                                            </Row>

                                        </Dropdown.Menu>
                                    </Dropdown>

                                </div>
                                {/* BT-121004 : Vinit Raut : 03-11-2023 Breeze- Hamburger Menu- Exchange Links bugfix - Start */}
                                <div data-testid="hamburger-menu-icon" className='shortmenu' onClick={() => dispatch(openHamburgerMenu())}>
                                    <BzToolTip placement='bottom' TooltipMsg='Menu'>
                                        <div data-testid='hamburger-icon' className='icon-24 icon-dark icon-hamburger d-flex flex-shrink-0'></div>
                                    </BzToolTip>
                                </div>
                                {/* BT-121004 : Vinit Raut : 03-11-2023 Breeze- Hamburger Menu- Exchange Links bugfix - End */}
                            </div>
                        </div>
                    </div>
                    {modals['USER_PROFILE_MODAL'] && <ProfileModal currentPreference={currentPreference} />}
                    <GuestUserProfileModal />
                    <ProfileSettingsModal userDetails={userDetails} setUserDetails={setUserDetails} setIsLocalStorageChanged={setIsLocalStorageChanged} handleUseAnotherAccount={handleUseAnotherAccount} />
                    <TermsConditionModal termsAndCondition={termsAndCondition} />
                    <UsageGuide />
                    <PrivacyPolicy />
                    <KeyboardShortcuts />
                    <AboutUsModal />
                    <ContactUs />
                    <LogOutConfirmationModal />
                    { /* BREEZE-4265 : Ravi R : 05-03-2025: Display segment wise version number - Start */}
                    <SegmentWiseVersionModal />
                    {/* BREEZE-4265 : Ravi R : 05-03-2025: Display segment wise version number - End */}


                    {modals['MARKET_STATUS'] && <MarketStatusModal />}
                    {/* // Parshva S - 12/12/2023 - BT-123521 : Breeze - Header Indices Start */}
                    {modals['HEADER_INDICES'] && <HeaderIndices indices={indices} />}
                    {/* // Parshva S - 12/12/2023 - BT-123521 : Breeze - Header Indices End */}
                    {/* Hari K:08-11-2023 :BT-119138:Funds View-added funds modal-start*/}
                    <Funds type={'header'} />
                    {/* Hari K:08-11-2023 :BT-119138:Funds View-added funds modal-end*/}
                    <ChangeMpin handleDoneMessage={handleDoneMessage} setDoneMessage={setDoneMessage} />
                    {/* Vaibhav Singh: 20-10-2023: Account Registration:  removed Modal from here  */}
                    <IFrame />
                </Container >
            </> : null
    );
};

export default memo(Header);

